<template>
  <div class="wrapper">
    <el-image class="top" style="width: 100%" src="https://show.malukeji.com/demo/page/static/img/01.png"
      fit="contain" alt="码路科技"></el-image>
    <div class="title">海报案例</div>
    <div class="tabs">
      <!-- <div class="tab_title">案例列表</div> -->
      <div class="tab" @click="activeTab(0)" :class="value == 0 ? 'active' : ''">全部</div>
      <div class="tab" v-for="(item, index) in options" :class="value == item.value ? 'active' : ''" :key="index"
        @click="activeTab(item.value)">
        {{ item.label }}
      </div>
    </div>
    <!-- <template v-for="(item, index) in options">
      <Waterfall v-if="value == item.value" :list="item.list" backgroundColor="#121212" :width="330" :row-key="index"
        :lazyload="false">
        <template #item="{ item, url, index }">
          <div class="card">
            <LazyImg :url="item.img" />
          </div>
        </template>
      </Waterfall>
    </template> -->
    <Waterfall ref="wat" :list="newlist" backgroundColor="#121212" :width="330" row-key="index0" :lazyload="false">
      <template #item="{ item, url, index }">
        <div class="card">
          <!-- <LazyImg :url="item.img" /> -->
          <el-image :preview-src-list="img_list" :src="item.img" fit="contain">
            <div slot="placeholder" class="image-slot">
              <el-skeleton style="width: 240px" animated>
                <template slot="template">
                  <el-skeleton-item variant="image" style="width: 240px; height: 240px;" />
                </template>
              </el-skeleton>
            </div>
          </el-image>
        </div>
      </template>
    </Waterfall>


    <!-- <div class="title">我们团队</div> -->
  </div>
</template>

<script>
import { LazyImg, Waterfall } from '../components/Waterfall'
import 'vue-waterfall-plugin/dist/style.css'
export default {
  name: "index",
  components: { Waterfall, LazyImg },
  data() {
    return {
      list: [],
      img_list: [],
      all_list: [],
      input: "",
      value: 0,
      options: [],
      gap: 20,
      column: 4,
      newlist: [],
      currentPage: 0,
      total: 0,
      pageSize: 20,
    };
  },
  mounted() {
    this.$http({
      method: "get",
      url: "https://show.malukeji.com/demo/page/data.json",
      // url: "static/data.json",
    })
      .then((res) => {
        this.img_list = res.data.poster.map((item) => item.img);
        this.list = res.data.poster;
        this.all_list = res.data.poster;
        this.options = res.data.poster_type.map((type) => {
          return {
            label: type.name,
            value: type.id,
            Pinyin: type.Pinyin,
            list: this.all_list.filter((item) => {
              return item.type_id == type.id;
            })
          };
        });
        this.total = this.list.length
        this.newlist = this.list.slice(this.currentPage * this.pageSize, this.currentPage * this
          .pageSize + this.pageSize)
        this.currentPage++
        window.addEventListener('scroll', this.handleScroll);
      })
      .catch((err) => {
        console.log(err);
      });
  },

  methods: {
    handleScroll() {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const bottomOfPage = windowHeight + scrollY >= documentHeight;
      if (bottomOfPage && this.newlist.length < this.total) {
        this.newlist = this.newlist.concat(this.list.slice(this.currentPage * this.pageSize, this.currentPage *
          this.pageSize + this.pageSize))
        this.currentPage++
      }
    },
    activeTab(value) {
      if (this.value != value) {
        this.value = value
        this.list = []
        if (value == 0) {
          this.list = this.all_list;
          this.currentPage = 0
          this.newlist = []
          this.total = this.list.length
          this.newlist = this.list.slice(this.currentPage * this.pageSize, this.currentPage * this.pageSize +
            this.pageSize)
          this.currentPage++
          return;
        }
          this.list = this.all_list.filter((item) => {
            return item.type_id == value;
          });
        console.log(this.list);
        this.currentPage = 0
        this.newlist = []
        this.total = this.list.length
        this.newlist = this.list.slice(this.currentPage * this.pageSize, this.currentPage * this.pageSize +
          this.pageSize)
        this.currentPage++
        // console.log(this.list)
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }

}
</script>

<style lang="scss">
.waterfall-list .card {
  background-color: #262626;
  padding: 10px;
  text-align: center;
}

.list-cont {
  width: 100%;
  display: flex;

  .data-list-box {
    width: 330px;

    .data-item {
      display: flex;
      margin-bottom: 25px;
      width: 300px;
      background-color: #262626;
      // height: 568rpx;
      padding: 30px 15px;
    }
  }
}

.el-image-viewer__btn {
  display: none !important;
}

.el-image-viewer__canvas {
  pointer-events: none;
}

@import "../assets/common.scss";
</style>


// WEBPACK FOOTER //
// src/pages/haibao.vue